<template>
  <span style="display: none;">Conversion tracker</span>
</template>

<script>
// import Cookies from 'js-cookie'

export default {
  props: {
    category: String,
    action: String,
    label: String,
    value: {
      default: 0,
      type: Number,
      required: false,
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.$gtm.trackEvent({
        event: 'event', // Event type [default = 'interaction'] (Optional)
        category: this.category,
        action: this.action,
        label: this.label,
        value: this.value,
        // noninteraction: false, // Optional
      })
    })
  }
}
</script>>